import $ from 'jquery';
import axios from 'axios';

const compatibilityToolInit = () => {
    // Targeting Elements
    const $component = $('.s-compatibility-tool');
    if (!$component.length) {
        return;
    }

    const $openMenu = $component.find('.js-open-menu');
    const $mobileMenu = $component.find('.c-mobile-menu');
    const $disclaimer = $component.find('.disclaimer');
    const $disclaimerReadBtn = $component.find('.disc-read-btn');
    const disclaimerText = $component
        .find('.disclaimer')[0]
        .querySelector('span').innerHTML;
    const $disclaimerLink = $component.find('.disclaimer-link');
    const $openIframe = $component.find('.js-open-iframe-modal');
    const $results = $component.find('.results');
    const $resultsHeadings = $component.find('.results-headings');
    const $noResult = $component.find('.no-result');
    const allResultsAPI = $component.attr('data-all-results');

    // APIs
    let results = '';

    axios.get(allResultsAPI).then(response => {
        results = response.data.map(
            result => {
                return `<div class="result">
                <div class="filter-item">
                    <div class="result-heading">DEVICE TYPE</div>
                    <div class="filter-item-result">${result.deviceType}</div>
                </div>
                <div class="filter-item">
                    <div class="result-heading">BRAND</div>
                    <div class="filter-item-result">${result.brand}</div>
                </div>
                <div class="compatible-item">
                    <div class="result-heading">COMPATIBLE</div>      
                    <div class="compatible-result">
                        <span>YES</span>
                        <svg class="svg-icon">
                            <use xlink:href="#tick"></use>
                        </svg>
                    </div>
                </div>
            </div>`;
            }
        );
        $results.append(results);
    });

    // changeable content
    $disclaimer[0].querySelector(
        'span'
    ).innerHTML = `${disclaimerText.substring(0, 200)}...`;
    $disclaimerLink[0].style.display = 'none';

    // Functions
    const disclaimerTextToggler = () => {
        if ($disclaimerReadBtn[0].innerHTML === 'read more') {
            $disclaimer[0].querySelector('span').innerHTML = disclaimerText;
            $disclaimerReadBtn[0].innerHTML = 'read less';
            $disclaimerLink[0].style.display = 'unset';
        } else {
            $disclaimer[0].querySelector(
                'span'
            ).innerHTML = `${disclaimerText.substring(0, 200)}...`;
            $disclaimerReadBtn[0].innerHTML = 'read more';
            $disclaimerLink[0].style.display = 'none';
        }
    };

    // Events
    $openMenu.on('click', () => {
        $mobileMenu.addClass('show');
    });

    $openIframe.on('click', () => {
        setTimeout(() => {
            const modal = document.querySelector('.mfp-content');
            const iframe = document.querySelector('.mfp-iframe');
            iframe.style.paddingBottom = '24px';
            modal.style.width = '1200px';
            modal.style.height = '560px';
        }, 0);
    });

    $disclaimerReadBtn.on('click', () => {
        disclaimerTextToggler();
    });

    document.addEventListener('filterBarString', event => {
        const myResults = document.querySelector('.results');
        while (myResults.hasChildNodes()) {
            myResults.removeChild(myResults.lastChild);
        }
        axios
            .get(`${allResultsAPI}?${event.detail.filterString}`)
            .then(response => {
                results = '';
                $noResult.removeClass('show');
                $disclaimer.show();
                $resultsHeadings.removeClass('hide');
                results = response.data.map(
                    result => {
                        return `<div class="result">
                    <div class="filter-item">
                        <div class="result-heading">DEVICE TYPE</div>
                        <div class="filter-item-result">${result.deviceType}</div>
                    </div>
                    <div class="filter-item">
                        <div class="result-heading">BRAND</div>
                        <div class="filter-item-result">${result.brand}</div>
                    </div>
                    <div class="compatible-item">
                        <div class="result-heading">COMPATIBLE</div>      
                        <div class="compatible-result">
                            <span>YES</span>
                            <svg class="svg-icon">
                                <use xlink:href="#tick"></use>
                            </svg>
                        </div>
                    </div>
                </div>`;
                    }
                );
                $results.append(results);

                if (!myResults.innerHTML) {
                    setTimeout(() => {
                        $results.append($noResult);
                        $noResult.addClass('show');
                        $disclaimer.hide();
                        $resultsHeadings.addClass('hide');
                    }, 0);
                }
            });
    });
};

$(() => {
    compatibilityToolInit();
});
